export default "__VITE_ASSET__81cdb9db__"